import { CSSProperties } from 'react';

import { useDisplay } from '~src/hooks/useDisplay';

import { Loader } from '../Loader';
import { OverlayModal } from '../Modal/OverlayModal';
import { LoadingScreen } from './LoadingScreen';

type Props = {
  setVisible?: (visible: boolean) => void;
  style?: CSSProperties;
};

export const LoadingOverlay = ({ setVisible }: Props) => {
  const { isMobile } = useDisplay();

  return (
    <OverlayModal
      background='blur'
      style={{
        display: 'flex',
        flexFlow: 'column wrap',
        backgroundColor: 'white',
        padding: '2rem',
        ...(isMobile && { width: '100vw', marginLeft: '-48px' }),
      }}
    >
      <LoadingScreen setVisible={setVisible} />

      <Loader />
    </OverlayModal>
  );
};
